module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column centered-start detalhe-item-container"
  }, [_c('div', {
    staticClass: "row-flex centered-between detalhe-titulo"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "item-detalhe-icone button-icone fa fa-remove",
    on: {
      "click": function($event) {
        return _vm.toggleDetalharItem(false)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between detalhe-titulo-sessao"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-end detalhe-mostrar-button",
    on: {
      "click": function($event) {
        _vm.showAll = !_vm.showAll
      }
    }
  }, [(!_vm.showAll) ? _c('div', [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" Detalhar Tudo\n        ")]) : _c('div', [_c('i', {
    staticClass: "fa fa-folder-open"
  }), _vm._v(" Esconder Detalhes\n        ")])])]), _vm._v(" "), _vm._l((_vm.itemCotacao['cotacao']), function(item, index) {
    return _c('div', {
      staticClass: "column all-centered detalhe-item-cotacao-container"
    }, [_c('detalheItemLicitacao', {
      attrs: {
        "itemLicitacao": item,
        "relatorioCotacao": true,
        "index": index + 1,
        "total": _vm.itemCotacao['cotacao'].length,
        "showAll": _vm.showAll
      }
    })], 1)
  }), _vm._v(" "), (_vm.itemCotacao.remocaoManual.length > 0) ? _c('div', {
    staticClass: "row-flex centered-start detalhe-titulo-sessao"
  }, [_c('i', {
    staticClass: "fa fa-user-times"
  }), _vm._v(" Itens Removidos Manualmente Pelo Usuário\n  ")]) : _vm._e(), _vm._v(" "), (_vm.itemCotacao.remocaoManual.length > 0) ? _c('div', {
    staticClass: "column all-centered detalhe-item-remocao-manual-container"
  }, _vm._l((_vm.itemCotacao.remocaoManual), function(item, index) {
    return _c('div', {
      staticClass: "column start-centered w-100"
    }, [_c('div', {
      staticClass: "detalhe-justificativa-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "row-flex centered-start detalhe-justificativa"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" Justificativa: "), _c('b', [_vm._v(_vm._s(item.justificativa))])]), _vm._v(" "), _c('div', {
      staticClass: "row-flex centered-start detalhe-justificativa"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" Responsável: "), _c('b', [_vm._v(_vm._s(item.responsavel))])]), _vm._v(" "), _c('detalheItemLicitacao', {
      attrs: {
        "itemLicitacao": item.item,
        "relatorioCotacao": true,
        "index": index + 1,
        "total": _vm.itemCotacao.remocaoManual.length,
        "showAll": _vm.showAll,
        "removidoManual": true
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column all-centered cotacao-calculo-container"
  }, [_c('div', {
    staticClass: "row-flex all-centered cotacao-calculo-tabela-container"
  }, [_c('div', {
    staticClass: "row-flex all-centered cotacao-tabelas"
  }, [_vm._m(3), _vm._v(" "), _c('tr', {
    staticClass: "column centered-start cotacao-tabela"
  }, [_c('td', {
    staticClass: "cotacao-tabela-header"
  }, [_vm._v("Universo Amostral Selecionado")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.media)))]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.DP)))]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm.calculoAmostral.CV) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LS)))]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LI)))])]), _vm._v(" "), _c('tr', {
    staticClass: "column centered-start cotacao-tabela"
  }, [_c('td', {
    staticClass: "cotacao-tabela-header"
  }, [_vm._v("Universo Amostral Saneado")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.calculoFinal.media)) + " (Média Saneada)")])]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% (CV Saneado)*")])]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "column all-centered cotacao-indicativo"
  }, [_c('div', {
    staticClass: "column all-centered cotacao-resumo"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "column all-end resumo-container"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.itemCotacao.cotacao.length + _vm.itemCotacao.universoAmostralSaneado.length) + " ")]), _vm._v(" Itens Encontrados\n                  ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.itemCotacao.universoAmostralSaneado.length) + " ")]), _vm._v(" Itens Saneados\n                  ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.itemCotacao.cotacao.length) + " ")]), _vm._v(" Itens Cotados\n                  ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% ")]), _vm._v(" Coeficiente de Variação\n                  ")])]), _vm._v(" "), (_vm.calculoFinal.CV <= 25 && _vm.calculoFinal.CV !== 0) ? _c('div', {
    staticClass: "row-flex all-centered diagnostico-card diagnostico-ok"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  }), _vm._v(" CV calculado indica razoável homogeneização do Valor.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.calculoFinal.CV > 25) ? _c('div', {
    staticClass: "row-flex all-centered diagnostico-card diagnostico-atencao"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" O CV calculado indica baixa homogeneização do Valor, atenção. Sujeito a análise.\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between preco-referencia-container"
  }, [_c('div', {
    staticClass: "column start-centered"
  }, [_c('div', {
    staticClass: "preco-referencia-titulo"
  }, [_vm._v("Preço de Referência:")]), _vm._v(" "), _c('div', {
    staticClass: "preco-referencia-subtitulo"
  }, [_vm._v("Universo Amostral: " + _vm._s(_vm.itemCotacao.cotacao.length + _vm.itemCotacao.universoAmostralSaneado.length))])]), _vm._v(" "), _c('div', {
    staticClass: "preco-referencia-calculo-final"
  }, [_vm._v("\n            " + _vm._s(_vm._f("real")(_vm.calculoFinal.media)) + "\n          ")])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start gap-10"
  }, [_c('i', {
    staticClass: "item-detalhe-icone fa fa-dollar"
  }), _vm._v(" Detalhamento de Cotação de Item de Despesa\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-object-ungroup"
  }), _vm._v(" Composição da Cotação\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start detalhe-titulo-sessao"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" Detalhamento do Calculo\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "column centered-start cotacao-tabela"
  }, [_c('td', {
    staticClass: "cotacao-tabela-header"
  }, [_vm._v("Variáveis")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Média")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Desvio Padrão (DP):")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Coeficiente de Variação (CV):")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Limite Superior (LS):")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Limite Inferior (LI):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start cotacao-titulo"
  }, [_c('i', {
    staticClass: "fa fa-map-pin"
  }), _vm._v(" Resumo:\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fe5a4a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/detalheItemCotacao.vue
// module id = 2010
// module chunks = 1